<template>
  <b-row style="width:100%">
    <b-col cols="12">
      <div style="display: block; margin: auto; height: 100%;width: 100%;">
        <canvas ref="chart"></canvas>
      </div>
    </b-col>
   
  </b-row>
</template>

<script>
import { Chart, registerables } from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
export default {
  props:['sectors'],  

  data() {
    return {
      colors_list: [
        "#9561E2",
        "#A574EC",
        "#B88EF6",
        "#E1CDFF",
        "#ECE0FF",
        "#F5F5F5"
      ],
      test: [],
    //   sectors: [
    //     {
    //       name: "Lyxor International Asset Management S.A.S.I",
    //       id: 56192,
    //       isin: "LU1834984798",
    //       value: 21.32216553
    //     },
    //     {
    //       name: "\nAMUNDI ETF EAST EUI",
    //       id: 46721,
    //       isin: "LU1681043755",
    //       value: 20.229038839999998
    //     },
    //     {
    //       name: "\nLYXOR UCITS ETF FTSE MIB DAI DOU SHT XBRD",
    //       id: 56930,
    //       isin: "FR0010446666",
    //       value: 34.29503158
    //     },
    //     {
    //       name: "\r\n AMUNDI PRIME EURO GOVIES UCITS ETF DR",
    //       id: 61957,
    //       isin: "LU1931975152",
    //       value: 8.77793192
    //     },
    //     {
    //       name: "\nISHARES $ TREAS BOND 1-3Y UCITS ETF ACCF",
    //       id: 57874,
    //       isin: "IE00B3VWN179",
    //       value: 15.37583213
    //     }
    //   ]
    };
  },
  mounted() {
    Chart.register(...registerables);
    var ctx = this.$refs.chart.getContext("2d");
    var labels = [];
    var values = [];
    var colors = [];
    var color_index = 0;
    this.sectors.forEach(sector => {
      labels.push(sector.name);
      values.push(Math.round(sector.value, 0));
      colors.push(this.colors_list[color_index]);
      color_index++;
      if (color_index == this.colors_list.length) {
        color_index = 0;
      }
    });

    // eslint-disable-next-line no-unused-vars
    var myChart = new Chart(ctx, {
      plugins: [ChartDataLabels],
      type: "doughnut",
      data: {
        labels: labels,
        datasets: [
          {
            data: values,
            backgroundColor: colors,
            borderColor: "#121212",
            hoverBorderColor: "rgba(255, 255, 255, .87)",
            borderWidth: 0,
            hoverBorderWidth: 2,
            hoverOffset: 5
          }
        ]
      },
      options: {
        maintainAspectRatio: false,
        cutoutPercentage: 70,
        responsive: true,
        plugins: {
          datalabels: {
            color: "#ffffff",
            labels: {
              title: {
                font: {
                  weight: "bold",
                  size: "14px"
                }
              }
            },
            formatter: value => {
              return value + "%";
            }
          },
          legend: {
            display: false
          },
          tooltip: {
            position: "nearest",
            borderColor: "rgba(0, 0, 255, 1)",
            callbacks: {
              label: function(context) {
                return context.label;
              }
            }
          }
        }
      }
    });
  }
};
</script>